module.exports = __webpack_public_path__ + "static/img/banner.2d7625dc.png";